import React, {useEffect} from 'react';

import Header from '../../partials/Header';
import PageIllustration from '../../partials/PageIllustration';
import PageIllustration2 from '../../partials/PageIllustration2';
import BlogSingleTresoEsg from '../../partials/BlogSingleTresoEsg';
import Footer from '../../partials/Footer';

function BlogPostTresoEsg() {

  useEffect(() => {
    document.title = `La trésorerie verte : comment intégrer des critères ESG dans la gestion de trésorerie et des investissements à court terme | CPI Software`
  }, [])
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="grow">
        <div className="relative max-w-6xl mx-auto h-0 pointer-events-none -z-1" aria-hidden="true">
          <PageIllustration />
          <PageIllustration2 />
        </div>
        {/*  Page sections */}
        <BlogSingleTresoEsg />
      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default BlogPostTresoEsg;